import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PropTypes from "prop-types";

/**
 * Componente reutilizável para alertas customizável pré-configurado para receber valores
 */
function OptionsSwal({
  title = null,
  icon = null,
  confirmButtonColor = "#34c38f",
  confirmButtonText = "Sim",
  denyButtonColor = "#f46a6a",
  denyButtonText = "Não",
  text = null,
  html = null,
  input = "text",
  inputLabel = null,
  required = false,
  requiredMessage = "",
  requiredCampos = ["swal2-input"],
  ...props
}) {
  const MySwal = withReactContent(Swal);

  return MySwal.fire({
    title: title,
    text: text,
    html: html,
    icon: icon,
    showConfirmButton: true,
    showDenyButton: true,
    confirmButtonText: confirmButtonText,
    denyButtonText: denyButtonText,
    confirmButtonColor: confirmButtonColor,
    denyButtonColor: denyButtonColor,
    input: input,
    inputLabel: inputLabel,
    preConfirm: required
      ? () => {
          let camposVazios = requiredCampos.filter(
            (campo) => !document.getElementById(campo).value
          );
          if (camposVazios.length > 0) {
            MySwal.showValidationMessage(requiredMessage);
          }
        }
      : null,
    ...props,
  });
}

OptionsSwal.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOf(["success", "error", "warning", "info", "question"]),
  confirmButtonColor: PropTypes.string,
  confirmButtonText: PropTypes.string,
  denyButtonColor: PropTypes.string,
  denyButtonText: PropTypes.string,
  text: PropTypes.string,
  html: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  input: PropTypes.string,
  inputLabel: PropTypes.string,
  required: PropTypes.bool,
  requiredMessage: PropTypes.string,
  requiredCampos: PropTypes.arrayOf(PropTypes.string),
};

export default OptionsSwal;
